import "regenerator-runtime/runtime";

function configUrl() {
  const location = window.location.href;
  const qualifUrl = 'https://www.rte.casino.osp.world/';
  const prodUrl = 'https://courses.monoprix.fr/';
  const qualifBucketPath = 'https://storage.googleapis.com/assets.miam.tech/monoprix/config/qualif/config.json';
  const prodBucketPath = 'https://storage.googleapis.com/assets.miam.tech/monoprix/config/prod/config.json';
  if (location.includes(qualifUrl)) {
    return qualifBucketPath;
  } else if (location.includes(prodUrl)) {
    return prodBucketPath;
  } else {
    console.debug("Location not found, can't choose right config, using prod one");
    return prodBucketPath;
  }
}

const defaultJson = {
  'available_shelves': [],
  'available_searches': [],
};

function fetchConfig(callback) {
  const url = configUrl();
  let xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.onload = () => {
    callback(JSON.parse(xhr.responseText));
  };
  xhr.onerror = () => {
    callback(defaultJson);
  };
  xhr.send();
}

export var Config = {
  config: {},

  async initConfig() {
    this.config = await new Promise(resolve => fetchConfig(resolve))
  },

  getAvailableShelves() {
    return this.config.available_shelves;
  },

  getAvailableSearches() {
    return this.config.available_searches;
  },

  getAbCssUrl() {
    return this.config.ab;
  }
}